import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import type { NoteItem } from 'tripPlanner/types/tripItem'
import CornerControls from '../DetailItemCard/common/CornerControls'
import Image from 'components/Common/Image/Image'
import BodyText from 'LuxKit/Typography/BodyText'

const CS_AGENT_AVATAR_ID = 'sguecuuhutatecxdgir'

const SuggestedNoteLayout = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  padding: ${rem(20)};
  break-inside: avoid-page;
  display: flex;
  gap: ${rem(8)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} ${rem(40)};
  }
`

const Avatar = styled(Image)`
  border-radius: 50%;
  width: ${rem(28)};
`

const Main = styled.div`
  flex: 1;
`

const NoteBody = styled(BodyText)`
  overflow-wrap: anywhere;
  margin-right: ${rem(40)};
  padding: ${rem(12)};
  background-color: ${(props) => props.theme.palette.highlight.secondary.lightBackground};
`

interface Props {
  item: NoteItem
}

function SuggestedNote({ item }: Props) {
  return (
    <SuggestedNoteLayout>
      <div>
        <Avatar id={CS_AGENT_AVATAR_ID} aspectRatio="1" gravity="north" />
      </div>
      <Main>
        <CornerControls item={item} />
        <NoteBody variant="medium" wrap="pre-wrap">
          {item.notes}
        </NoteBody>
      </Main>
    </SuggestedNoteLayout>
  )
}

export default SuggestedNote
